export const formatDate = (dateString) => {
  if (isNaN(Date.parse(dateString))) return dateString;
  const date = new Date(dateString);
  const options = { month: "short", day: "numeric", year: "numeric" };
  const formattedDate = new Intl.DateTimeFormat("en-US", options).format(
    date
  );

  // Add 'th', 'st', 'nd', 'rd' suffix to the day
  const day = date.getDate();
  const daySuffix = (day) => {
    if (day > 3 && day < 21) return "th";
    switch (day % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  };

  return formattedDate.replace(/\d+/, `${day}${daySuffix(day)}`);
};